export const CUSTOM_COLUMNS_SORT_FILTER_LIMIT = 3;
